<template>
  <div>
    NotifyPayment.vue
    <br />
    {{paymentInfo}}
  </div>
</template>

<script>
export default {
  mounted() {
    this.paymentInfo = this.$route.query;
  },
  data: () => ({
    paymentInfo: null
  })
};
</script>

<style>
</style>